const getters = {
  token: state => state.user.token,
  passwordResponse: state => state.user.passwordResponse,
  user: state => state.user.user,
  menuStatus: state => state.user.menuStatus,
  modules: state => state.user.modules,
  btnpermission: state => state.user.btnpermission,
  normalQuery: state => {
    state.flight.normalQuery = JSON.parse(localStorage.getItem('normalQuery'))
    return state.flight.normalQuery
  },
  loginSessionId: state => {
    state.user.loginSessionId = JSON.parse(localStorage.getItem('loginSessionId'))
    return state.user.loginSessionId
  }
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js